import type { ParsedContent } from '../parse-response-content';

export const extractReadableText = (parsedContent: ParsedContent[]): string => {
  const parts: string[] = [];

  for (const item of parsedContent) {
    switch (item.type) {
      case 'text':
      case 'warning':
        parts.push(item.content);
        break;
      case 'thinking':
        parts.push(`Thinking: ${item.content}`);
        break;
      case 'chart':
        if (item.content.spec?.title) {
          parts.push(`Chart: ${item.content.spec.title}`);
        }
        break;
    }
  }

  return parts.join('\n\n');
};
